import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

class PositionModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modal: false
    }
  }

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }))
  }

  render () {
    const { title, body } = this.props
    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
        <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
        <ModalBody>
          {body}
        </ModalBody>
        <ModalFooter>
          <Button color='primary' outline onClick={this.toggle}>Cancel</Button>
          <a
            href={`mailto:recruitment@tungtung.vn?subject=TTVN – Internship – ${title}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            <Button color='primary'>Apply Now</Button>
          </a>
        </ModalFooter>
      </Modal>
    )
  }
}

export default PositionModal
